/* eslint-disable react/require-default-props */
import React from 'react';
import camelToCapitalize from '@utils/functions/camelToCapitalize';
import snakeToCapitalize from '@utils/functions/snakeToCapitalize';
import { translate } from '@utils/i18n';
import { humanizeInspectableType } from '../../utils/humanizeInspectableType';
import { IssueStatusEnum } from '../../types';
import ManagerNote from './ManagerNote';
import IssueLayout from './IssueLayout';
import DeviceInfoToggle from './DeviceInfoToggle';
import './styles.scss';
export default function DriftingValuesCard({ issue, defaultExpanded, onToggle, onUpdateIssue, onUndoAction, readOnly = false, onDeviceInfoToggle }) {
    var _a, _b, _c, _d, _e, _f;
    const status = issue.status || IssueStatusEnum.Detected;
    // Handler functions for issue actions
    const handleSuggestCorrection = () => {
        onUpdateIssue(issue.id, status, true);
    };
    const handleDismissIssue = () => {
        onUpdateIssue(issue.id, IssueStatusEnum.DismissedByBackOffice, false);
    };
    const handleNoteChange = (note) => {
        onUpdateIssue(issue.id, status, issue.markedForSuggestion, note);
    };
    return (React.createElement(IssueLayout, { issueType: "significant_value_change", status: status, defaultExpanded: defaultExpanded, onToggle: onToggle, onSuggestCorrection: handleSuggestCorrection, onDismissIssue: handleDismissIssue, onUndoAction: onUndoAction, readOnly: readOnly, statusChanges: issue.statusChanges, markedForSuggestion: issue.markedForSuggestion },
        React.createElement(React.Fragment, null,
            React.createElement("p", null,
                React.createElement("span", null, translate('drifting_values_description', {
                    namespace: 'features.iim_review.issue_card'
                })),
                React.createElement("hr", { className: "section__split" }),
                React.createElement("b", null,
                    ((_a = issue.question) === null || _a === void 0 ? void 0 : _a.type) && camelToCapitalize(issue.question.type),
                    " /",
                    ' ',
                    humanizeInspectableType((_b = issue.inspectable) === null || _b === void 0 ? void 0 : _b.type)),
                React.createElement("br", null),
                React.createElement("span", null,
                    snakeToCapitalize((_c = issue.issueData) === null || _c === void 0 ? void 0 : _c.fieldName),
                    " on",
                    ' ',
                    camelToCapitalize((_d = issue.inspectable) === null || _d === void 0 ? void 0 : _d.data.name)),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("span", { className: "issue-card__label" },
                    React.createElement("b", null,
                        translate('out_of_spec_current', { namespace: 'features.iim_review.issue_card' }),
                        ":")),
                React.createElement("br", null),
                React.createElement("div", { className: "issue-card__current-value" },
                    React.createElement("div", { className: "issue-card__current-value-box" },
                        React.createElement("i", { className: "fa-light fa-circle-exclamation" }),
                        React.createElement("span", { className: "issue-card__current-value-text" }, (_e = issue.issueData.parsedValue) !== null && _e !== void 0 ? _e : issue.issueData.payloadValue))),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("span", { className: "issue-card__label" },
                    React.createElement("b", null,
                        translate('out_of_spec_expected_range', { namespace: 'features.iim_review.issue_card' }),
                        ":")),
                React.createElement("br", null),
                React.createElement("span", null,
                    Math.round(issue.issueData.min),
                    " - ",
                    Math.round(issue.issueData.max))),
            React.createElement(DeviceInfoToggle, { inspectable: issue.inspectable, onToggle: onDeviceInfoToggle }),
            issue.markedForSuggestion && (!readOnly || ((_f = issue.managerNote) === null || _f === void 0 ? void 0 : _f.trim())) && (React.createElement("div", { className: "issue-card__body" },
                React.createElement(ManagerNote, { note: issue.managerNote || '', onNoteChange: handleNoteChange, disabled: readOnly }))))));
}
